module.exports = __webpack_public_path__ + "static/media/dog.cabd43c0.jpg";